import {CfgTaskTypeAutodestinationModel} from './cfg-task-type-autodestination.model';
import {TdoUserConfigurationModel} from './user/tdo-user-configuration.model';
import {TdoUserGroupConfigurationModel} from './user/tdo-user-group-configuration.model';

export class CfgTaskTypeAutoDestinationListModel extends CfgTaskTypeAutodestinationModel {
  User: TdoUserConfigurationModel;
  UserGroup: TdoUserGroupConfigurationModel;
  Type: string;
  Destination: string; // user name or user group name
}
